import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Learn about staking and risks' },
});
